import { useState } from 'react';

import { extractTridionGameInformation } from '@/utils/document-utils';

import FullscreenLoading from './FullscreenLoading';

interface FullscreenGameProps {
  htmlContent?: string;
}

const FullscreenGame: React.FC<FullscreenGameProps> = ({ htmlContent }) => {
  const [gameIsLoading, setGameIsLoading] = useState(false);
  const gameInformation = extractTridionGameInformation(htmlContent);
  const iframeUrl = gameInformation?.url;

  if (!iframeUrl) {
    return <FullscreenLoading />;
  }

  return (
    <>
      <div className="h-[calc(100dvh-var(--header-height))] w-full overflow-y-hidden pt-4">
        <iframe
          allow="fullscreen"
          className="size-full"
          src={iframeUrl}
          onLoad={() => setGameIsLoading(false)}
          title="Game"
        />
      </div>
      {gameIsLoading && (
        <FullscreenLoading className="absolute h-[calc(100dvh-var(--header-height))] w-full bg-white" />
      )}
    </>
  );
};

export default FullscreenGame;
